var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "company-switcher__search" }, [
    _c(
      "label",
      { staticClass: "company-switcher__search-field" },
      [
        _c("lucide-icon", {
          staticClass: "company-switcher__search-icon",
          attrs: { icon: _vm.icons.search, size: 16, "aria-hidden": "true" },
        }),
        _c("input", {
          ref: "input",
          staticClass: "company-switcher__search-input",
          attrs: {
            type: "text",
            role: "combobox",
            autocomplete: "off",
            "aria-autocomplete": "list",
            "aria-expanded": "true",
            "aria-controls": _vm.listboxId,
            "aria-activedescendant": _vm.activeOptionId,
            "aria-label": _vm.$t("buscarempresa"),
            placeholder: _vm.$t("buscarempresa"),
          },
          domProps: { value: _vm.value },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event.target.value)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }